export const googleMapsQueryUrl = (address) =>
  `https://maps.google.com/?q=${encodeURIComponent(address || '')}`;

/** Single-line address for display and Google Maps (delivery fields, job_location, or API full line). */
export const formatJobDeliveryLine = (job) => {
  if (!job) return '';
  if (job.delivery_address) {
    return `${job.delivery_address}${job.delivery_city ? `, ${job.delivery_city}` : ''}${job.delivery_state ? `, ${job.delivery_state}` : ''}${job.delivery_zip ? ` ${job.delivery_zip}` : ''}`.trim();
  }
  const loc = String(job.job_location || '').trim();
  if (loc) return loc;
  return String(job.get_full_delivery_address || '').trim();
};
